/**
 * AssessmentShell — chrome around the adaptive flow.
 * Optional `progress` slot for the ProgressIndicator (welcome / outcome hide it).
 */
import { Sparkles } from "lucide-react";

export default function AssessmentShell({ children, progress, hideProgress = false }) {
  return (
    <div className="kcis-assessment-bg min-h-screen pb-20">
      <header className="sticky top-0 z-30 backdrop-blur bg-white/70 border-b border-purple-100/60">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 py-3 flex items-center gap-2">
          <span className="inline-flex h-7 w-7 rounded-full bg-purple-900 text-white items-center justify-center">
            <Sparkles className="h-3.5 w-3.5" />
          </span>
          <span className="kcis-assessment-display text-base sm:text-lg">KCIS™</span>
          <span className="kcis-assessment-overline ml-auto">Reflection</span>
        </div>
        {!hideProgress && progress && (
          <div className="max-w-2xl mx-auto px-4 sm:px-6 pb-3">{progress}</div>
        )}
      </header>

      <main className="max-w-2xl mx-auto px-4 sm:px-6 py-6 sm:py-10">
        {children}
      </main>
    </div>
  );
}
